import {
  Button,
  Center,
  Flex,
  Image,
  Spacer,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure
} from "@chakra-ui/react";
import React from "react";
import { HiMenu } from "react-icons/hi";
import Sidebar from "./Sidebar";

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/login";
  };

  return (
    <Flex h="full" w="full" align="center" p={2}>
      {/* Hamburger + Logo on small screens */}
      <Flex display={["flex", "flex", "flex", "none"]} align="center" gap={2}>
        <IconButton
          icon={<HiMenu size={25} />}
          variant="ghost"
          aria-label="Open Menu"
          onClick={onOpen}
        />
        <Image
          src="logoname.png"
          h={["24px", "26px", "28px"]}
          maxW="120px"
          alt="LOGO"
        />
      </Flex>

      {/* Logo on desktop */}
      <Center
        w="13rem"
        minW="13rem"
        display={["none", "none", "none", "flex"]}
      >
        <Image
          src="logoname.png"
          h="30px"
          w="70%"
          alt="LOGO"
          objectFit="contain"
        />
      </Center>

      <Spacer />

      {/* Logout desktop */}
      <Flex align="center" pr={10} display={["none", "none", "none", "flex"]}>
        <Button variant="link" onClick={handleLogout}>
          Log Out
        </Button>
      </Flex>

      {/* Logout mobile */}
      <Flex align="center" pr={2} display={["flex", "flex", "flex", "none"]}>
        <Button variant="link" onClick={handleLogout}>
          Log Out
        </Button>
      </Flex>

      {/* Drawer */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent maxW="250px">
          <Sidebar onClose={onClose} />
        </DrawerContent>
      </Drawer>
    </Flex>
  );
};

export default Header;
